import ClimateContainer from './containers/ClimateContainer';

export default ClimateContainer;
